module.exports = __webpack_public_path__ + "static/logo-ae36a7a2d4880e148ecb93e554a1b61c.png";